<!-- Close button -->
<div class="absolute top-3 right-3">
  <button mat-mini-fab aria-label="Dialog schließen" [mat-dialog-close]="true" color="light">
    <mat-icon svgIcon="sli-schliessen-gross-20"></mat-icon>
  </button>
</div>
<!-- End close button -->

<!-- Content -->
<mat-dialog-content>

  @if ((newsItem$ | async); as newsItem) {
    <div>
      <div class="m-6">
        @if ((documentViewerError$ | async) !== true) {
          <div>
            <button mat-button class="w-fit -ml-4" aria-label="Teilen per Mail" color="light" (click)="shareByMail(newsItem)">
              <mat-icon svgIcon="fi-teilen-20"></mat-icon>
              <span>{{ 'common.caption_share' | translate }}</span>
            </button>
          </div>
        }
        <div class="max-w-[50rem]">
          <myupdates-html-viewer class="document-viewer-base document-viewer-announcement" [documentId]="newsItem.detail.documentId">
          </myupdates-html-viewer>
        </div>
      </div>
      @if ( (documentViewerError$ | async)) {
        <myupdates-error-box class="error-box-white-style -mt-5"
                             [errorTitle]="documentViewerErrorTitle"
                             [errorText]="documentViewerErrorText"
                             [showServiceTimeNotice]="documentViewerErrorServiceTimeNotice">
        </myupdates-error-box>
      }
    </div>
  } @else {
    @if ( (errorInfo$ | async)) {
      <myupdates-error-box class="error-box-white-style"
                           [errorTitle]="dataRequestErrorTitle"
                           [errorText]="dataRequestErrorText"
                           [showServiceTimeNotice]="dataRequestErrorServiceTimeNotice">
      </myupdates-error-box>
    } @else {
      <mat-spinner class="mx-20 my-4 text-petrol-500"></mat-spinner>
    }
  }

</mat-dialog-content>
<!-- End content -->
